<div class="swal-without-margin info-tooltip settings-dialog">
  <mat-label class="section-title">
    {{ 'menu.settings' | translate }}
    <span class="tooltip-row">
      <button mat-icon-button (click)="onCancel()" aria-label="Close dialog" class="close-button">
        <span class="material-symbols-outlined icon-close-button">close</span>
      </button>
    </span>
  </mat-label>

  <div class="settings-container compact-form-field">
    <div class="loading-spinner" *ngIf="loading">
      <div class="spinner-load"></div>
    </div>

    <!-- Notifica cambiamenti dispositivi -->
    <div class="device-change-alert" *ngIf="deviceChangeDetected">
      <span class="font-icon-button material-symbols-outlined">info</span>
      <span>{{ 'SETTINGS.DEVICE_CHANGE_DETECTED' | translate }}</span>
    </div>
    <div class="security-warning" *ngIf="deviceChangeDetected">
      <span class="font-icon-button material-symbols-outlined">security</span>
      <div class="warning-content">
        <strong>{{ 'SETTINGS.SECURITY_WARNING_TITLE' | translate }}</strong>
        <p>{{ 'SETTINGS.DEVICE_CHANGE_WARNING' | translate }}</p>
      </div>
    </div>
    <div class="call-in-progress" *ngIf="config.AS?.phoneStatus === phoneStatuses.TALKING">
      <span class="font-icon-button material-symbols-outlined pulse">phone_in_talk</span>
      <div class="call-info">
        <strong>{{ 'SETTINGS.CALL_IN_PROGRESS' | translate }}</strong>
        <p>{{ 'SETTINGS.DEVICE_CHANGE_DURING_CALL' | translate }}</p>
      </div>
    </div>

    <!-- Lingua -->
    <div class="setting-section">
      <h5>{{ 'menu.settings.language' | translate }}</h5>
      <mat-form-field appearance="fill" >
        <mat-select (selectionChange)="changeLanguage($event)" [(value)]="selectedLang">
          <mat-option [value]="lang.language" *ngFor="let lang of LANGUAGES">
            {{ lang.tip }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <!-- Audio Output -->
    <div class="setting-section">
      <h5>
        <div>{{ 'menu.settings.audiooutput' | translate }}</div>
        <!-- Progress bar per test speaker - sempre presente ma invisibile quando non attiva -->
        <div class="speaker-progress-container" [class.visible]="isSpeakerTesting">
          <div class="speaker-progress-track">
            <div class="speaker-progress-indicator" [style.left.%]="speakerProgress"></div>
          </div>
        </div>
        <button mat-button color="primary" (click)="testSpeakers()" class="test-button" [disabled]="audioOutContext">
          <span class="font-icon-button material-symbols-outlined">volume_up</span>
          {{ 'SETTINGS.TEST_SPEAKERS' | translate }}
        </button>
      </h5>
      <mat-form-field appearance="fill">
        <mat-select (selectionChange)="changeMediaDevice('audioOutput', $event)" [(value)]="selectedAudioOutput"
          placeholder="{{mediaDeviceService.getDefaultDeviceLabel('audiooutput')}}"
        >
          <mat-option [value]="dev.deviceId" *ngFor="let dev of mediaDeviceService.audioOutputs; index as i">
            {{ dev.label || 'speaker ' + (i+1) }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <!-- Audio Input -->
    <div class="setting-section">
      <h5>
        <div>{{ 'menu.settings.audiointput' | translate }}</div>
        <!-- Volume meter -->
        <div class="volume-meter" *ngIf="isMicrophoneTesting">
          <div class="volume-bar" [style.width.%]="microphoneVolume"></div>
        </div>
        <button mat-button color="primary"
              (click)="toggleMicrophoneTest()"
              [disabled]="!hasMicrophonePermission"
              class="test-button">

          <span class="font-icon-button material-symbols-outlined">{{ isMicrophoneTesting ? 'stop' : 'mic' }}</span>
          {{ (isMicrophoneTesting ? 'SETTINGS.STOP_TEST' : 'SETTINGS.TEST_MICROPHONE') | translate }}
        </button>
      </h5>

      <mat-form-field appearance="fill">
        <mat-select (selectionChange)="changeMediaDevice('audioInput', $event)" [(value)]="selectedAudioInput"
        placeholder="{{mediaDeviceService.getDefaultDeviceLabel('audioinput')}}">
          <mat-option [value]="dev.deviceId" *ngFor="let dev of mediaDeviceService.audioInputs; index as i">
            {{ dev.label || 'microphone ' + (i+1) }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Test microfono -->



    </div>

    <!-- Camera -->
    <div class="setting-section">
      <h5>{{ 'menu.settings.camera' | translate }}
          <button mat-button
                  (click)="toggleVideoPreview()"
                  [disabled]="!hasCameraPermission"
                  class="test-button">
            <span class="font-icon-button material-symbols-outlined">{{ isVideoPreviewActive ? 'videocam_off' : 'videocam' }}</span>
            {{ (isVideoPreviewActive ? 'SETTINGS.STOP_PREVIEW' : 'SETTINGS.PREVIEW_CAMERA') | translate }}
          </button>
      </h5>

      <mat-form-field appearance="fill">
        <mat-select (selectionChange)="changeMediaDevice('camera', $event)" [(value)]="selectedCamera"
          placeholder="{{mediaDeviceService.getDefaultDeviceLabel('videoinput')}}">
          <mat-option [value]="dev.deviceId" *ngFor="let dev of mediaDeviceService.videoInputs; index as i">
            {{ dev.label || 'camera ' + (i+1) }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      
      <!-- Preview video -->
      <div class="video-preview-container" *ngIf="isVideoPreviewActive">
        <video #videoPreview 
                autoplay 
                muted 
                playsinline
                class="video-preview"
                [class.mirror]="shouldMirrorVideo()">
        </video>
      </div>
    </div>
    
    <!-- Azioni -->
    <div class="actions-section">
      <button mat-raised-button color="secondary" (click)="resetToDefault()" [matTooltip]="'menu.settings.resetToDefault.hint' | translate">
        {{ 'menu.settings.resetToDefault' | translate }}
      </button>
      <button mat-raised-button class="button-blueb80" (click)="saveChanges()">
        {{ 'POPUP.SAVE' | translate }}
      </button>
    </div>
  </div>
</div>